import { Component, HostListener, OnInit, ViewContainerRef } from '@angular/core';
import {
  MatDialog,
  MatDialogConfig,
} from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';
import notify from 'devextreme/ui/notify';
import { BillingDocumentService } from './billing-documents.service';
import { BillingDocumentsPDFModalComponent } from './billing-documents-pdf-modal/billing-documents-pdf-modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { BillingDocumentsModalComponent } from './billing-documents-modal/billing-documents-modal.component';
import { IBillingDocument, IBillingDocumentFilter, IBillingDocumentNames, IBillingDocumentTypes } from './billing-documents.interface';
import { Overlay } from '@angular/cdk/overlay';
import { InvoiceStatuses, InvoiceStatusesColors, InvoiceStatusesFilterOptions, InvoiceStatusesLabels } from './billing-documents.constants';
import { CorrectiveInvoiceModalComponent } from './corrective-invoice-modal/corrective-invoice-modal.component';
import { CorrectiveInvoiceService } from './corrective-invoice-modal/corrective-invoice.service';
import { BillingDocumentsBulkModalComponent } from './billing-documents-bulk-modal/billing-documents-bulk-modal.component';
import { Broadcaster } from '../../../shared/components/broadcaster.component';
import { AuthService } from '../../../shared/services/auth.service';
import { AlertService } from '../../../shared/services/alert.service';
import { DialogService } from '../../../shared/services/dialog/dialog.service';
import { UtilsService } from '../../../shared/services/utils.service';
import { IConfirmationDialogOptions } from '../../../shared/services/dialog/confirmation-dialog/confirmation-dialog-options.interface';
import { IInformationDialogOptions } from '../../../shared/services/dialog/information-dialog/information-dialog-options.interface';

let self: any;

@Component({
  selector: 'app-billing-documents',
  templateUrl: './billing-documents.component.html',
  styleUrls: ['./billing-documents.component.css']
})
export class BillingDocumentsComponent implements OnInit {
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.screenWidth = window.innerWidth;
  }

  screenWidth: number;
  loading: boolean = false;
  thereAreMore: boolean = false;
  curr!: string;
  filter: IBillingDocumentFilter = {
    filters: {
      isDeleted: undefined,
      status: 'ACTIVE'
    },
    sort: '-createdAt',
    skip: 0,
    limit: 20
  };
  filtered = false;
  scrollSubscription!: Subscription;
  selection: any = { all: false };
  isDev!: boolean;
  documents: any;
  isCurrent: boolean = false;
  // dialog: MatDialogRef<any>;
  currentDate: any;
  subtotals: number = 0;
  taxes: number = 0;
  totals: number = 0;

  invoiceStatusesLabels: any = InvoiceStatusesLabels;
  invoiceStatusesColors: any = InvoiceStatusesColors;
  invoiceStatuses: any = InvoiceStatuses;
  invoiceStatusesKeys = Object.keys(InvoiceStatuses);
  invoiceFilterOptions = InvoiceStatusesFilterOptions;
  invoiceFilterOptionsKeys = Object.keys(InvoiceStatusesFilterOptions);
  querySubscription!: Subscription;

  billingDocumentTypes = IBillingDocumentTypes;

  constructor(
    private _BillingDocumentService: BillingDocumentService,
    private _CorrectiveInvoiceService: CorrectiveInvoiceService,
    private _broadcaster: Broadcaster,
    // public dialogRef: MatDialogRef<any>,
    private _dialog: MatDialog,
    private _viewContainerRef: ViewContainerRef,
    private _AuthService: AuthService,
    private router: Router,
    private alertService: AlertService,
    private _dialogService: DialogService,
    private _UtilsService: UtilsService,
    private overlay: Overlay,
    private _route: ActivatedRoute,
  ) {
    self = this;
    this.screenWidth = window.innerWidth;
    // this.dialog = dialogRef;
    this.registerQueryParamChanges();
    this.registerStringBroadcast();
  }

  registerQueryParamChanges() {
    this.querySubscription = this._route.queryParams.subscribe(params => {
      if (params['action'] && parseInt(params['tp'] || '0') > (new Date().getTime() - (10 * 1000)) && (params['action'] == 'NEW'))
        setTimeout(() => this.openNewBDocumentModal('INVOICE'));
    })
  }

  ngOnInit() {
    this.isDev = this._AuthService.isRole('dev');
    this.curr = this._AuthService.currency();
    this.filter.company = this._AuthService.companyId();
    this.getDocuments(true);
  }

  lazySearchTmp: number = 0;
  lazySearch() {
    let tmp = new Date().getTime();
    this.lazySearchTmp = tmp;
    setTimeout(() => {
      console.log(tmp, this.lazySearchTmp);
      if (tmp == this.lazySearchTmp) {
        this.getDocuments(true);
      }
    }, 1000);
  }

  getDocuments(reset?: boolean) {
    this.loading = true;
    this.thereAreMore = false;
    this.currentDate = new Date();
    this.currentDate = this._UtilsService.date.toUTC(this.currentDate.toISOString())
    this.subtotals = 0;
    this.taxes = 0;
    this.totals = 0;
    if (reset) {
      window.scroll(0, 0);
      this.filter.skip = 0;
      this.documents = [];
      this.clearSelection();
    }
    const filter: any = _.cloneDeep(this.filter);
    if (filter.filters.dateStart) filter.filters.dateStart = this._UtilsService.date.toUTC(filter.filters.dateStart + 'T00:00:00.000Z');
    if (filter.filters.dateEnd) filter.filters.dateEnd = this._UtilsService.date.toUTC(filter.filters.dateEnd + 'T23:59:59.999Z');

    if (filter.filters.dueDateStart) filter.filters.dueDateStart = this._UtilsService.date.toUTC(filter.filters.dueDateStart + 'T00:00:00.000Z');
    if (filter.filters.dueDateEnd) filter.filters.dueDateEnd = this._UtilsService.date.toUTC(filter.filters.dueDateEnd + 'T23:59:59.999Z');

    if (filter.filters.totalMin == null) delete filter.filters.totalMin;
    if (filter.filters.totalMax == null) delete filter.filters.totalMax;
    this._BillingDocumentService.getBillingDocuments(filter).subscribe((documents: any) => {
      /* REFACTOR **********************************
          El filtrado no deberia hacerse en el front
          Maxi: Quite el filtrado del overdue porque ahora lo envio por backend. Dejo esta sentencia por si necesitan ese otro dato luego sino quitarlo
      */
      if (documents && documents.length > 0) {
        const documentFiltred = documents.filter((el: any) => {
          if (this.isCurrent === undefined) {
            //el.overdue = new Date(el.dueDate) > new Date(this.currentDate);
            return true;
          } else {
            //console.log(new Date(el.dueDate))
            //el.overdue = new Date(el.dueDate) > new Date(this.currentDate);
            return el.isDeleted === this.isCurrent;
          }
        });
        this.documents = _.concat(this.documents, documentFiltred);
        /* REFACTOR ***********************************/
        this.documents.forEach((doc: any) => {
          const subtotal = doc.subtotal || 0;
          const total = doc.total || 0;

          this.subtotals += subtotal;
          this.totals += total;

          if (doc.correctiveInvoice) {
            const correctiveSubtotal = doc.correctiveInvoice.subtotal || 0;
            const correctiveTotal = doc.correctiveInvoice.total || 0;

            this.subtotals += correctiveSubtotal;
            this.totals += correctiveTotal;
          }
        });

        this.totals = Math.round(this.totals * 100) / 100;
        this.subtotals = Math.round(this.subtotals * 100) / 100;
        this.taxes = Math.round((this.totals - this.subtotals) * 100) / 100;

        this.thereAreMore = documents.length >= self.filter.limit;
      }
      this.loading = false;
    })
  }

  loadMore() {
    if (this.thereAreMore && !this.loading) {
      self.filter.skip += self.filter.limit;
      this.getDocuments();
    }
  }

  registerStringBroadcast() {
    this.scrollSubscription = this._broadcaster.on<string>('FinishScrollDown')
      .subscribe(() => {
        this.loadMore();
      });
  }

  ngOnDestroy() {
    this.scrollSubscription.unsubscribe();
  }

  openDocumentCI(document: any) {
    let config = new MatDialogConfig();
    config.width = '1200px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.pdfDialogRef = this._dialog.open(BillingDocumentsPDFModalComponent, config);
    self.pdfDialogRef.componentInstance.correctiveInvoice = document.correctiveInvoice;

    self.pdfDialogRef.afterClosed().subscribe((result: any) => {
      self.pdfDialogRef = null;
    });
  }

  downloadCI(document: any) {
    const name = `Factura Rectificadora ${document.correctiveInvoice.serie + '000' + document.correctiveInvoice.number} de ${this._AuthService.company().name}`;
    this._CorrectiveInvoiceService.download(document.correctiveInvoice._id, name);
  }

  sendEmailCI(document: any) {
    if (document.client.emails.length > 0) {

      const modalOptions: IConfirmationDialogOptions = {
        title: "Enviar por email",
        message: "¿Desea enviar la factura a la siguiente dirección? " + (document.client as any).emails[0].address,
        yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
      };

      this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
        .subscribe((confirmation: any) => {
          if (confirmation) {
            let data = {};
            this._CorrectiveInvoiceService.sendEmail(document.correctiveInvoice._id, data).subscribe((result: any) => {
              result ? notify(`Email enviado correctamente`, "info", 1500) : notify(`Error al enviar email`, "error", 1500);
            });
          }
        });
    } else {
      this.alertService.warn("El cliente no tiene un email cargado");
    }
  }

  openDocument(document: any) {
    let config = new MatDialogConfig();
    config.width = '1200px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.pdfDialogRef = this._dialog.open(BillingDocumentsPDFModalComponent, config);
    self.pdfDialogRef.componentInstance.document = document;

    self.pdfDialogRef.afterClosed().subscribe((result: any) => {
      self.pdfDialogRef = null;
    });
  }

  download(document: any) {
    const isDraft = document.status === this.invoiceStatuses.DRAFT;
    const name = isDraft
      ? `Factura de ${this._AuthService.company().name} - Vto. ${document.dueDate.substr(0, 10)} (BORRADOR)`
      : `Factura ${document.serieAndNumber} de ${this._AuthService.company().name} - Vto. ${document.dueDate.substr(0, 10)}`;
    this._BillingDocumentService.download(document._id, name);
  }

  downloadReceipt(document: any) {
    const name = `Recibo por Factura ${document.serieAndNumber} de ${this._AuthService.company().name}`;
    const id = document.receipt._id ? document.receipt._id : document.receipt;
    this._BillingDocumentService.downloadReceipt(id, name);
  }

  sendEmail(document: any) {
    if (document.client.emails.length > 0) {

      const modalOptions: IConfirmationDialogOptions = {
        title: "Enviar por email",
        message: "¿Desea enviar la factura a la siguiente dirección? " + document.client.emails[0].address,
        yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
      };

      this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
        .subscribe((confirmation: any) => {
          if (confirmation) {
            let data = {};
            this._BillingDocumentService.sendEmail(document._id, data).subscribe((result: any) => {
              result ? notify(`Email enviado correctamente`, "info", 1500) : notify(`Error al enviar email`, "error", 1500);
            });
          }
        });
    } else {
      this.alertService.warn("El cliente no tiene un email cargado");
    }
  }

  isGreaterThan672px(): boolean {
    return this.screenWidth > 672;
  }

  openFilter() {
    console.log('openFilter');
  }

  clearFilter() {
    this.filter.filters = { isDeleted: undefined };
    this.getDocuments(true);
  }

  clearSelection() {
    this.selection = { all: false }
  }


  openCorrectiveInvoiceModal(document: IBillingDocument, readOnly = false) {
    let config = new MatDialogConfig();
    config.width = '1200px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.pdfDialogRef = this._dialog.open(CorrectiveInvoiceModalComponent, config);
    self.pdfDialogRef.componentInstance.invoice = document;
    self.pdfDialogRef.componentInstance.readOnly = readOnly;

    self.pdfDialogRef.afterClosed().subscribe((result: any) => {
      self.pdfDialogRef = null;
      if (result) this.getDocuments(true);
    });
  }

  openNewBDocumentModal(type: IBillingDocumentNames) {
    let config = new MatDialogConfig();
    config.width = '1200px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.pdfDialogRef = this._dialog.open(BillingDocumentsModalComponent, config);
    self.pdfDialogRef.componentInstance.document = { type: type };

    self.pdfDialogRef.afterClosed().subscribe((result: any) => {
      self.pdfDialogRef = null;
      if (result) this.getDocuments(true);
    });
  }

  openDefaultAction(document: IBillingDocument) {
    if (document.status == this.invoiceStatuses.DRAFT) this.openEditDocument(document);
    if (document.status == this.invoiceStatuses.ISSUED) this.openEditDocument(document);
    if (document.status == this.invoiceStatuses.PAID) this.openDocument(document);
    if (document.status == this.invoiceStatuses.CANCELLED) this.openDocument(document);
  }

  openEditDocument(document: IBillingDocument) {
    let config = new MatDialogConfig();
    config.width = '1200px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    config.scrollStrategy = this.overlay.scrollStrategies.block();
    self.dialogRef = this._dialog.open(BillingDocumentsModalComponent, config);
    self.dialogRef.componentInstance.document = document;
    self.dialogRef.componentInstance.readOnly = true;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
      if (result) this.getDocuments(true);
    });
  }

  setPaidInvoice(document: IBillingDocument) {

    const modalOptions: IConfirmationDialogOptions = {
      title: "Registrar Pago",
      message: "Desea registrar pago para esta Factura?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };

    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          this._BillingDocumentService.updateBillingDocument({ _id: document._id, status: this.invoiceStatuses.PAID }).subscribe(async result => {
            await this.createReceipt(document);
            this.getDocuments(true);
          });
        }
      });
  }

  async createReceipt(document: IBillingDocument) {
    // REFACTOR: docs list with client._id
    let data = await this._BillingDocumentService.getBillingDocument(document).toPromise();
    let body = {
      company: data.company._id,
      client: data.client._id,
      paymentDate: new Date(),
      dueDate: new Date(),
      billingDocument: data._id,
      total: data.total,
      termsAndConditions: data.termsAndConditions,
      paymentMethod: data.paymentMethod,
      paymentMethodType: data.paymentMethodType
    }
    const receipt = this._BillingDocumentService.createReceipt(body).toPromise();
    return receipt;
  }

  removePaymentsInvoice(document: IBillingDocument) {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Eliminar Pago",
      message: "Si elimina el pago, la factura dejará de estar en estado “Pagada”.",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };

    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          this._BillingDocumentService.deleteReceipt(document.receipt).subscribe(result => {
            this._BillingDocumentService.updateBillingDocument({
              _id: document._id, status: this.invoiceStatuses.ISSUED
            }).subscribe(result => {
              this.getDocuments(true);
            });
          });
        }
      });
  }

  openNewBDocumentFromTasksModal() {
    this.router.navigate(['/admin', this._AuthService.companyIndex(), 'tasks'], { queryParams: { action: 'INVOICE' } }).then(() => {
      window.location.reload();
    });
  }

  openNewBDocumentFromServiceAgreements() {
    this.router.navigate(['/admin', this._AuthService.companyIndex(), 'agreements'], { queryParams: { action: 'INVOICE' } }).then(() => {
      window.location.reload();
    });
  }

  openDeleteBillingDocConfirm(document: IBillingDocument) {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Eliminar Factura",
      message: `Esta seguro que desea eliminar factura borrador ${document.docNumber || document.number || ''}?`,
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };

    const tieneTask = document.details?.some(detail => !!detail.task);

    if (tieneTask && document.status != "DRAFT") {
      this.alertService.error('No se pueden eliminar facturas que estén asociadas a un trabajo');
    } else {
      this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
        .subscribe((confirmation: any) => {
          if (confirmation) {
            this._BillingDocumentService.deleteBillingDocument(document).subscribe(() => {
              document.isDeleted = true;
              this.getDocuments(true);
            });
          }
        });
    }
  }

  openRestoreBillingDocConfirm(document: IBillingDocument) {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Restaurar Factura",
      message: `Esta seguro que desea restaurar factura ${document.docNumber || document.number || ''}?`,
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };
    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          this._BillingDocumentService.restoreBillingDocument(document).subscribe(() => {
            document.isDeleted = false;
          })
        }
      });
  }

  openUnderConstructionDialog() {
    const modalOptions: IInformationDialogOptions = {
      title: "¡Próximamente!",
      message: "Esta funcionalidad se encuentra en construcción.",
      closeButtonLabel: "Ok"
    };
    this._dialogService.openInformationModal(modalOptions, this._viewContainerRef)
      .subscribe(() => {
        console.log('ok')
      });
  }

  openModalGenerateZip() {
    let config = new MatDialogConfig();
    config.width = '1200px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    config.scrollStrategy = this.overlay.scrollStrategies.block();
    self.dialogRef = this._dialog.open(BillingDocumentsBulkModalComponent, config);
    self.dialogRef.componentInstance.readOnly = false;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
      if (result) this.getDocuments(true);
    });
  }

}